import * as React from 'react';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Paper,
  Divider,
  Button,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import FieldOptions from './FieldOptions';
import type { IJobDetail } from './JobInterfaces';

interface IEditJobDetailProps {
  setJobFormValues: (values: IJobDetail) => void;
  JobFormValues: IJobDetail;
}

const AddFieldOptions: React.FC<IEditJobDetailProps> = ({
  setJobFormValues, JobFormValues,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleAddNewFieldOption = (fieldIndex: number) => {
    if (JobFormValues.jobFields.some((field) => field.fieldOptions.some((fieldOption) => fieldOption.name === ''))) {
      enqueueSnackbar('Cannot add new field options, while previous field option is not filled out', { variant: 'error' });
    } else {
      const tempField = [...JobFormValues.jobFields];
      const tempFieldOptions = [...JobFormValues.jobFields[fieldIndex].fieldOptions];
      tempFieldOptions.push({ id: null, name: '', inUse: false });
      tempField[fieldIndex].fieldOptions = tempFieldOptions;
      setJobFormValues({ ...JobFormValues, jobFields: tempField });
    }
  };

  const handleFieldOptionRemove = (fieldIndex: number, fieldOptionIndex: number) => {
    const temp = [...JobFormValues.jobFields];
    temp[fieldIndex].fieldOptions.splice(fieldOptionIndex, 1);
    if (fieldOptionIndex === 0 && temp[fieldIndex].fieldOptions.length === 0) {
      temp.splice(fieldIndex, 1);
    }
    setJobFormValues({ ...JobFormValues, jobFields: temp });
  };

  const handleAddNewField = () => {
    if (JobFormValues.jobFields.some((field) => field.fieldName === '' || field.fieldOptions.some((fieldOption) => fieldOption.name === ''))) {
      enqueueSnackbar('Cannot add a new field, while previous fields are not filled out', { variant: 'error' });
    } else {
      const temp = [...JobFormValues.jobFields];
      temp.push({
        fieldInUse: false,
        fieldName: '',
        fieldOptions: [{ id: null, name: '', inUse: false }],
      });
      setJobFormValues({ ...JobFormValues, jobFields: temp });
    }
  };

  return (
    <Grid>
      <Box>
        <Card>
          <Paper>
            <CardHeader title="Fields and Field Options" />
            <Divider variant="fullWidth" />
            <CardContent>
              <FieldOptions
                formValues={JobFormValues}
                setFormValues={setJobFormValues}
                handleAddNewFieldOption={handleAddNewFieldOption}
                handleFieldOptionRemove={handleFieldOptionRemove}
              />
              <Grid item xs={11} container justifyContent="flex-start">
                <Grid item xs={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => { handleAddNewField(); }}
                  >
                    {'Add a new field'}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        </Card>
      </Box>
    </Grid>
  );
};

export default AddFieldOptions;
